export var AbandonedCartsSortField;
(function (AbandonedCartsSortField) {
    AbandonedCartsSortField["AbandonTime"] = "AbandonTime";
    AbandonedCartsSortField["AbandonedDate"] = "AbandonedDate";
})(AbandonedCartsSortField || (AbandonedCartsSortField = {}));
export var ActionType;
(function (ActionType) {
    ActionType["CAPTURE"] = "CAPTURE";
    ActionType["UNKNOWN_ACTION_TYPE"] = "UNKNOWN_ACTION_TYPE";
    ActionType["VOID"] = "VOID";
})(ActionType || (ActionType = {}));
export var ActiveStatus;
(function (ActiveStatus) {
    ActiveStatus["Active"] = "Active";
    ActiveStatus["Archived"] = "Archived";
})(ActiveStatus || (ActiveStatus = {}));
export var ActivityType;
(function (ActivityType) {
    ActivityType["CUSTOM_ACTIVITY"] = "CUSTOM_ACTIVITY";
    ActivityType["DOWNLOAD_LINK_SENT"] = "DOWNLOAD_LINK_SENT";
    ActivityType["EMAIL_EDITED"] = "EMAIL_EDITED";
    ActivityType["FULFILLER_EMAIL_SENT"] = "FULFILLER_EMAIL_SENT";
    ActivityType["INVOICE_ADDED"] = "INVOICE_ADDED";
    ActivityType["INVOICE_REMOVED"] = "INVOICE_REMOVED";
    ActivityType["INVOICE_SENT"] = "INVOICE_SENT";
    ActivityType["MERCHANT_COMMENT"] = "MERCHANT_COMMENT";
    ActivityType["NEW_EXCHANGE_ORDER_CREATED"] = "NEW_EXCHANGE_ORDER_CREATED";
    ActivityType["ORDER_CANCELED"] = "ORDER_CANCELED";
    ActivityType["ORDER_CREATED_FROM_EXCHANGE"] = "ORDER_CREATED_FROM_EXCHANGE";
    ActivityType["ORDER_FULFILLED"] = "ORDER_FULFILLED";
    ActivityType["ORDER_NOT_FULFILLED"] = "ORDER_NOT_FULFILLED";
    ActivityType["ORDER_PAID"] = "ORDER_PAID";
    ActivityType["ORDER_PLACED"] = "ORDER_PLACED";
    ActivityType["ORDER_REFUNDED"] = "ORDER_REFUNDED";
    ActivityType["PICKUP_READY_EMAIL_SENT"] = "PICKUP_READY_EMAIL_SENT";
    ActivityType["SHIPPING_ADDRESS_EDITED"] = "SHIPPING_ADDRESS_EDITED";
    ActivityType["SHIPPING_CONFIRMATION_EMAIL_SENT"] = "SHIPPING_CONFIRMATION_EMAIL_SENT";
    ActivityType["TRACKING_LINK_ADDED"] = "TRACKING_LINK_ADDED";
    ActivityType["TRACKING_NUMBER_ADDED"] = "TRACKING_NUMBER_ADDED";
    ActivityType["TRACKING_NUMBER_EDITED"] = "TRACKING_NUMBER_EDITED";
})(ActivityType || (ActivityType = {}));
export var AdjustNumberType;
(function (AdjustNumberType) {
    AdjustNumberType["INCREASE_BY_AMOUNT"] = "INCREASE_BY_AMOUNT";
    AdjustNumberType["INCREASE_BY_PERCENTAGE"] = "INCREASE_BY_PERCENTAGE";
    AdjustNumberType["REDUCE_BY_AMOUNT"] = "REDUCE_BY_AMOUNT";
    AdjustNumberType["REDUCE_BY_PERCENTAGE"] = "REDUCE_BY_PERCENTAGE";
    AdjustNumberType["SET_NEW"] = "SET_NEW";
})(AdjustNumberType || (AdjustNumberType = {}));
export var AppliedDiscountDiscountType;
(function (AppliedDiscountDiscountType) {
    AppliedDiscountDiscountType["GLOBAL"] = "GLOBAL";
    AppliedDiscountDiscountType["SHIPPING"] = "SHIPPING";
    AppliedDiscountDiscountType["SPECIFIC_ITEMS"] = "SPECIFIC_ITEMS";
})(AppliedDiscountDiscountType || (AppliedDiscountDiscountType = {}));
export var AttributionSource;
(function (AttributionSource) {
    AttributionSource["FACEBOOK_ADS"] = "FACEBOOK_ADS";
    AttributionSource["UNSPECIFIED"] = "UNSPECIFIED";
})(AttributionSource || (AttributionSource = {}));
export var AuthorizationCaptureStatus;
(function (AuthorizationCaptureStatus) {
    AuthorizationCaptureStatus["FAILED"] = "FAILED";
    AuthorizationCaptureStatus["PENDING"] = "PENDING";
    AuthorizationCaptureStatus["SUCCEEDED"] = "SUCCEEDED";
    AuthorizationCaptureStatus["UNKNOWN_STATUS"] = "UNKNOWN_STATUS";
})(AuthorizationCaptureStatus || (AuthorizationCaptureStatus = {}));
export var AuthorizationVoidStatus;
(function (AuthorizationVoidStatus) {
    AuthorizationVoidStatus["FAILED"] = "FAILED";
    AuthorizationVoidStatus["PENDING"] = "PENDING";
    AuthorizationVoidStatus["SUCCEEDED"] = "SUCCEEDED";
    AuthorizationVoidStatus["UNKNOWN_STATUS"] = "UNKNOWN_STATUS";
})(AuthorizationVoidStatus || (AuthorizationVoidStatus = {}));
export var BackInStockRequestStatus;
(function (BackInStockRequestStatus) {
    BackInStockRequestStatus["FAILED"] = "FAILED";
    BackInStockRequestStatus["NOTIFICATION_SENT"] = "NOTIFICATION_SENT";
    BackInStockRequestStatus["PROCESSING"] = "PROCESSING";
    BackInStockRequestStatus["RECEIVED"] = "RECEIVED";
    BackInStockRequestStatus["UNSPECIFIED"] = "UNSPECIFIED";
})(BackInStockRequestStatus || (BackInStockRequestStatus = {}));
export var BulkApplyDiscountType;
(function (BulkApplyDiscountType) {
    BulkApplyDiscountType["AMOUNT"] = "AMOUNT";
    BulkApplyDiscountType["DELTA"] = "DELTA";
    BulkApplyDiscountType["PERCENT"] = "PERCENT";
})(BulkApplyDiscountType || (BulkApplyDiscountType = {}));
export var CategoryFieldName;
(function (CategoryFieldName) {
    CategoryFieldName["id"] = "id";
    CategoryFieldName["name"] = "name";
    CategoryFieldName["numOfProducts"] = "numOfProducts";
    CategoryFieldName["parentCategoryId"] = "parentCategoryId";
})(CategoryFieldName || (CategoryFieldName = {}));
export var ChannelType;
(function (ChannelType) {
    ChannelType["AMAZON"] = "AMAZON";
    ChannelType["BACKOFFICE_MERCHANT"] = "BACKOFFICE_MERCHANT";
    ChannelType["CLASS_PASS"] = "CLASS_PASS";
    ChannelType["EBAY"] = "EBAY";
    ChannelType["ETSY"] = "ETSY";
    ChannelType["FACEBOOK"] = "FACEBOOK";
    ChannelType["FAIRE_COM"] = "FAIRE_COM";
    ChannelType["GLOBAL_E"] = "GLOBAL_E";
    ChannelType["OTHER_PLATFORM"] = "OTHER_PLATFORM";
    ChannelType["POS"] = "POS";
    ChannelType["TIKTOK"] = "TIKTOK";
    ChannelType["UNSPECIFIED"] = "UNSPECIFIED";
    ChannelType["WEB"] = "WEB";
    ChannelType["WISH"] = "WISH";
    ChannelType["WIX_APP_STORE"] = "WIX_APP_STORE";
    ChannelType["WIX_INVOICES"] = "WIX_INVOICES";
})(ChannelType || (ChannelType = {}));
export var ChargeType;
(function (ChargeType) {
    ChargeType["HANDLING_FEE"] = "HANDLING_FEE";
    ChargeType["INSURANCE"] = "INSURANCE";
})(ChargeType || (ChargeType = {}));
export var ConditionType;
(function (ConditionType) {
    ConditionType["BY_TOTAL_PRICE"] = "BY_TOTAL_PRICE";
    ConditionType["BY_TOTAL_QUANTITY"] = "BY_TOTAL_QUANTITY";
    ConditionType["BY_TOTAL_WEIGHT"] = "BY_TOTAL_WEIGHT";
    ConditionType["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
})(ConditionType || (ConditionType = {}));
export var ContentTypes;
(function (ContentTypes) {
    ContentTypes["gift"] = "gift";
    ContentTypes["merchandise"] = "merchandise";
    ContentTypes["other"] = "other";
})(ContentTypes || (ContentTypes = {}));
export var CouponErrorType;
(function (CouponErrorType) {
    CouponErrorType["EXPIRED"] = "EXPIRED";
})(CouponErrorType || (CouponErrorType = {}));
export var CreateInvoiceErrorCode;
(function (CreateInvoiceErrorCode) {
    CreateInvoiceErrorCode["INVALID_EMAIL"] = "INVALID_EMAIL";
    CreateInvoiceErrorCode["INVALID_PRICE_AMOUNT"] = "INVALID_PRICE_AMOUNT";
    CreateInvoiceErrorCode["MISSING_CONTACT"] = "MISSING_CONTACT";
    CreateInvoiceErrorCode["MISSING_CONTACT_EMAIL"] = "MISSING_CONTACT_EMAIL";
})(CreateInvoiceErrorCode || (CreateInvoiceErrorCode = {}));
export var CreateOrderFulfillmentStatus;
(function (CreateOrderFulfillmentStatus) {
    CreateOrderFulfillmentStatus["FULFILLED"] = "FULFILLED";
    CreateOrderFulfillmentStatus["NOT_FULFILLED"] = "NOT_FULFILLED";
    CreateOrderFulfillmentStatus["PARTIALLY_FULFILLED"] = "PARTIALLY_FULFILLED";
})(CreateOrderFulfillmentStatus || (CreateOrderFulfillmentStatus = {}));
export var DataFetchType;
(function (DataFetchType) {
    DataFetchType["ADDITIONAL_FEES"] = "ADDITIONAL_FEES";
    DataFetchType["DISCOUNT"] = "DISCOUNT";
    DataFetchType["ORDER_VALIDATION"] = "ORDER_VALIDATION";
    DataFetchType["SHIPPING"] = "SHIPPING";
})(DataFetchType || (DataFetchType = {}));
export var DayOfWeek;
(function (DayOfWeek) {
    DayOfWeek["FRI"] = "FRI";
    DayOfWeek["MON"] = "MON";
    DayOfWeek["SAT"] = "SAT";
    DayOfWeek["SUN"] = "SUN";
    DayOfWeek["THU"] = "THU";
    DayOfWeek["TUE"] = "TUE";
    DayOfWeek["WED"] = "WED";
})(DayOfWeek || (DayOfWeek = {}));
export var DescriptionLineType;
(function (DescriptionLineType) {
    DescriptionLineType["COLOR"] = "COLOR";
    DescriptionLineType["PLAIN_TEXT"] = "PLAIN_TEXT";
    DescriptionLineType["UNRECOGNISED"] = "UNRECOGNISED";
})(DescriptionLineType || (DescriptionLineType = {}));
export var DiscountDiscountType;
(function (DiscountDiscountType) {
    DiscountDiscountType["FIXED_AMOUNT"] = "FIXED_AMOUNT";
    DiscountDiscountType["FIXED_PRICE"] = "FIXED_PRICE";
    DiscountDiscountType["PERCENTAGE"] = "PERCENTAGE";
    DiscountDiscountType["UNDEFINED"] = "UNDEFINED";
})(DiscountDiscountType || (DiscountDiscountType = {}));
export var DiscountMode;
(function (DiscountMode) {
    DiscountMode["Amount"] = "Amount";
    DiscountMode["Percent"] = "Percent";
})(DiscountMode || (DiscountMode = {}));
export var DiscountReason;
(function (DiscountReason) {
    DiscountReason["EXCHANGED_ITEMS"] = "EXCHANGED_ITEMS";
    DiscountReason["UNSPECIFIED"] = "UNSPECIFIED";
})(DiscountReason || (DiscountReason = {}));
export var DiscountType;
(function (DiscountType) {
    DiscountType["GLOBAL"] = "GLOBAL";
    DiscountType["SHIPPING"] = "SHIPPING";
    DiscountType["SPECIFIC_ITEMS"] = "SPECIFIC_ITEMS";
})(DiscountType || (DiscountType = {}));
export var EmailNotificationsConfiguration;
(function (EmailNotificationsConfiguration) {
    EmailNotificationsConfiguration["OFF"] = "OFF";
    EmailNotificationsConfiguration["ON_ORDER_CREATED"] = "ON_ORDER_CREATED";
    EmailNotificationsConfiguration["ON_ORDER_PAID"] = "ON_ORDER_PAID";
})(EmailNotificationsConfiguration || (EmailNotificationsConfiguration = {}));
export var EmailStatusType;
(function (EmailStatusType) {
    EmailStatusType["NOT_SENT"] = "NOT_SENT";
    EmailStatusType["SCHEDULED"] = "SCHEDULED";
    EmailStatusType["SENT"] = "SENT";
})(EmailStatusType || (EmailStatusType = {}));
export var ErrorTypes;
(function (ErrorTypes) {
    ErrorTypes["MISSING_PARAMETER"] = "MISSING_PARAMETER";
    ErrorTypes["OUT_OF_RANGE"] = "OUT_OF_RANGE";
    ErrorTypes["SERVICE_UNAVAILABLE"] = "SERVICE_UNAVAILABLE";
})(ErrorTypes || (ErrorTypes = {}));
export var FallbackReason;
(function (FallbackReason) {
    FallbackReason["AUTO_TAX_DEACTIVATED"] = "AUTO_TAX_DEACTIVATED";
    FallbackReason["AUTO_TAX_FAILED"] = "AUTO_TAX_FAILED";
})(FallbackReason || (FallbackReason = {}));
export var FieldName;
(function (FieldName) {
    FieldName["NAME"] = "NAME";
    FieldName["START_DATE"] = "START_DATE";
    FieldName["TYPE"] = "TYPE";
})(FieldName || (FieldName = {}));
export var FileType;
(function (FileType) {
    FileType["SECURE_ARCHIVE"] = "SECURE_ARCHIVE";
    FileType["SECURE_DOCUMENT"] = "SECURE_DOCUMENT";
    FileType["SECURE_MUSIC"] = "SECURE_MUSIC";
    FileType["SECURE_PICTURE"] = "SECURE_PICTURE";
    FileType["SECURE_VIDEO"] = "SECURE_VIDEO";
    FileType["UNSPECIFIED"] = "UNSPECIFIED";
})(FileType || (FileType = {}));
export var FilterOperators;
(function (FilterOperators) {
    FilterOperators["BETWEEN"] = "BETWEEN";
    FilterOperators["CONTAINS"] = "CONTAINS";
    FilterOperators["CONTAINS_ALL"] = "CONTAINS_ALL";
    FilterOperators["CONTAINS_ANY"] = "CONTAINS_ANY";
    FilterOperators["EQUALS"] = "EQUALS";
    FilterOperators["EXISTS"] = "EXISTS";
    FilterOperators["GT"] = "GT";
    FilterOperators["GTE"] = "GTE";
    FilterOperators["IN"] = "IN";
    FilterOperators["IN_ALL"] = "IN_ALL";
    FilterOperators["LT"] = "LT";
    FilterOperators["LTE"] = "LTE";
    FilterOperators["MATCH"] = "MATCH";
    FilterOperators["NEQUALS"] = "NEQUALS";
    FilterOperators["START_WITH"] = "START_WITH";
})(FilterOperators || (FilterOperators = {}));
export var FulfillmentStatus;
(function (FulfillmentStatus) {
    FulfillmentStatus["Canceled"] = "Canceled";
    FulfillmentStatus["FULFILLED"] = "FULFILLED";
    FulfillmentStatus["Fulfilled"] = "Fulfilled";
    FulfillmentStatus["NOT_FULFILLED"] = "NOT_FULFILLED";
    FulfillmentStatus["NotFulfilled"] = "NotFulfilled";
    FulfillmentStatus["PARTIALLY_FULFILLED"] = "PARTIALLY_FULFILLED";
    FulfillmentStatus["PartiallyFulfilled"] = "PartiallyFulfilled";
})(FulfillmentStatus || (FulfillmentStatus = {}));
export var GiftCardError;
(function (GiftCardError) {
    GiftCardError["GIFT_CARD_CODE_INVALID"] = "GIFT_CARD_CODE_INVALID";
    GiftCardError["GIFT_CARD_CURRENCY_INVALID"] = "GIFT_CARD_CURRENCY_INVALID";
    GiftCardError["GIFT_CARD_DISABLED"] = "GIFT_CARD_DISABLED";
    GiftCardError["GIFT_CARD_EXPIRED"] = "GIFT_CARD_EXPIRED";
    GiftCardError["GIFT_CARD_GENERAL_ERROR"] = "GIFT_CARD_GENERAL_ERROR";
    GiftCardError["GIFT_CARD_INSUFFICIENT_BALANCE"] = "GIFT_CARD_INSUFFICIENT_BALANCE";
    GiftCardError["GIFT_CARD_IS_EMPTY"] = "GIFT_CARD_IS_EMPTY";
    GiftCardError["GIFT_CARD_SERVICE_UNAVAILABLE"] = "GIFT_CARD_SERVICE_UNAVAILABLE";
})(GiftCardError || (GiftCardError = {}));
export var GiftCardErrorType;
(function (GiftCardErrorType) {
    GiftCardErrorType["EXPIRED"] = "EXPIRED";
})(GiftCardErrorType || (GiftCardErrorType = {}));
export var InventoryStatus;
(function (InventoryStatus) {
    InventoryStatus["IN_STOCK_STATUS"] = "IN_STOCK_STATUS";
    InventoryStatus["NOT_OUT_OF_STOCK_STATUS"] = "NOT_OUT_OF_STOCK_STATUS";
    InventoryStatus["OUT_OF_STOCK_STATUS"] = "OUT_OF_STOCK_STATUS";
    InventoryStatus["PARTIALLY_OUT_OF_STOCK_STATUS"] = "PARTIALLY_OUT_OF_STOCK_STATUS";
})(InventoryStatus || (InventoryStatus = {}));
export var InventoryUpdatingMode;
(function (InventoryUpdatingMode) {
    InventoryUpdatingMode["OnOrderCreated"] = "OnOrderCreated";
    InventoryUpdatingMode["OnOrderPaid"] = "OnOrderPaid";
    InventoryUpdatingMode["Unknown"] = "Unknown";
})(InventoryUpdatingMode || (InventoryUpdatingMode = {}));
export var ItemAvailabilityStatus;
(function (ItemAvailabilityStatus) {
    ItemAvailabilityStatus["AVAILABLE"] = "AVAILABLE";
    ItemAvailabilityStatus["NOT_AVAILABLE"] = "NOT_AVAILABLE";
    ItemAvailabilityStatus["NOT_FOUND"] = "NOT_FOUND";
    ItemAvailabilityStatus["PARTIALLY_AVAILABLE"] = "PARTIALLY_AVAILABLE";
})(ItemAvailabilityStatus || (ItemAvailabilityStatus = {}));
export var ItemTypeItemType;
(function (ItemTypeItemType) {
    ItemTypeItemType["DIGITAL"] = "DIGITAL";
    ItemTypeItemType["GIFT_CARD"] = "GIFT_CARD";
    ItemTypeItemType["PHYSICAL"] = "PHYSICAL";
    ItemTypeItemType["SERVICE"] = "SERVICE";
    ItemTypeItemType["UNRECOGNISED"] = "UNRECOGNISED";
})(ItemTypeItemType || (ItemTypeItemType = {}));
export var JurisdictionType;
(function (JurisdictionType) {
    JurisdictionType["CITY"] = "CITY";
    JurisdictionType["COUNTRY"] = "COUNTRY";
    JurisdictionType["COUNTY"] = "COUNTY";
    JurisdictionType["SPECIAL"] = "SPECIAL";
    JurisdictionType["STATE"] = "STATE";
    JurisdictionType["UNDEFINED"] = "UNDEFINED";
})(JurisdictionType || (JurisdictionType = {}));
export var LengthUnit;
(function (LengthUnit) {
    LengthUnit["KM"] = "KM";
    LengthUnit["MI"] = "MI";
    LengthUnit["UNSPECIFIED_LENGTH_UNIT"] = "UNSPECIFIED_LENGTH_UNIT";
})(LengthUnit || (LengthUnit = {}));
export var LineItemEnum;
(function (LineItemEnum) {
    LineItemEnum["CUSTOM_AMOUNT_ITEM"] = "CUSTOM_AMOUNT_ITEM";
    LineItemEnum["DIGITAL"] = "DIGITAL";
    LineItemEnum["PHYSICAL"] = "PHYSICAL";
    LineItemEnum["UNSPECIFIED_LINE_ITEM_TYPE"] = "UNSPECIFIED_LINE_ITEM_TYPE";
})(LineItemEnum || (LineItemEnum = {}));
export var LineItemQuantityChangeType;
(function (LineItemQuantityChangeType) {
    LineItemQuantityChangeType["QUANTITY_DECREASED"] = "QUANTITY_DECREASED";
    LineItemQuantityChangeType["QUANTITY_INCREASED"] = "QUANTITY_INCREASED";
})(LineItemQuantityChangeType || (LineItemQuantityChangeType = {}));
export var LockableOperation;
(function (LockableOperation) {
    LockableOperation["LOCKED"] = "LOCKED";
    LockableOperation["UNLOCKED"] = "UNLOCKED";
})(LockableOperation || (LockableOperation = {}));
export var LockedOperations;
(function (LockedOperations) {
    LockedOperations["DuplicateProduct"] = "DuplicateProduct";
    LockedOperations["ManageProductInventory"] = "ManageProductInventory";
    LockedOperations["ManageProductPricing"] = "ManageProductPricing";
    LockedOperations["ManageProductVariants"] = "ManageProductVariants";
})(LockedOperations || (LockedOperations = {}));
export var LogicalOperator;
(function (LogicalOperator) {
    LogicalOperator["EQ"] = "EQ";
    LogicalOperator["GT"] = "GT";
    LogicalOperator["GTE"] = "GTE";
    LogicalOperator["LT"] = "LT";
    LogicalOperator["LTE"] = "LTE";
    LogicalOperator["UNKNOWN_LOGICAL_OPERATOR_TYPE"] = "UNKNOWN_LOGICAL_OPERATOR_TYPE";
})(LogicalOperator || (LogicalOperator = {}));
export var ManualCalculationReason;
(function (ManualCalculationReason) {
    ManualCalculationReason["GLOBAL_SETTING_TO_MANUAL"] = "GLOBAL_SETTING_TO_MANUAL";
    ManualCalculationReason["REGION_SETTING_TO_MANUAL"] = "REGION_SETTING_TO_MANUAL";
})(ManualCalculationReason || (ManualCalculationReason = {}));
export var MarkOrderAsPaidErrorCode;
(function (MarkOrderAsPaidErrorCode) {
    MarkOrderAsPaidErrorCode["NO_OFFLINE_PAYMENT"] = "NO_OFFLINE_PAYMENT";
    MarkOrderAsPaidErrorCode["ORDER_ALREADY_PAID"] = "ORDER_ALREADY_PAID";
    MarkOrderAsPaidErrorCode["ORDER_NOT_APPROVED"] = "ORDER_NOT_APPROVED";
    MarkOrderAsPaidErrorCode["PAYMENT_GATEWAY_ID_NOT_FOUND"] = "PAYMENT_GATEWAY_ID_NOT_FOUND";
})(MarkOrderAsPaidErrorCode || (MarkOrderAsPaidErrorCode = {}));
export var MeasurementUnitType;
(function (MeasurementUnitType) {
    MeasurementUnitType["cbm"] = "cbm";
    MeasurementUnitType["cl"] = "cl";
    MeasurementUnitType["cm"] = "cm";
    MeasurementUnitType["floz"] = "floz";
    MeasurementUnitType["ft"] = "ft";
    MeasurementUnitType["g"] = "g";
    MeasurementUnitType["gal"] = "gal";
    MeasurementUnitType["in"] = "in";
    MeasurementUnitType["kg"] = "kg";
    MeasurementUnitType["l"] = "l";
    MeasurementUnitType["lb"] = "lb";
    MeasurementUnitType["m"] = "m";
    MeasurementUnitType["mg"] = "mg";
    MeasurementUnitType["ml"] = "ml";
    MeasurementUnitType["mm"] = "mm";
    MeasurementUnitType["oz"] = "oz";
    MeasurementUnitType["pt"] = "pt";
    MeasurementUnitType["qt"] = "qt";
    MeasurementUnitType["sqft"] = "sqft";
    MeasurementUnitType["sqm"] = "sqm";
    MeasurementUnitType["yd"] = "yd";
})(MeasurementUnitType || (MeasurementUnitType = {}));
export var MediaItemEnum;
(function (MediaItemEnum) {
    MediaItemEnum["PHOTO"] = "PHOTO";
    MediaItemEnum["UNSUPPORTED"] = "UNSUPPORTED";
})(MediaItemEnum || (MediaItemEnum = {}));
export var MediaItemType;
(function (MediaItemType) {
    MediaItemType["audio"] = "audio";
    MediaItemType["document"] = "document";
    MediaItemType["image"] = "image";
    MediaItemType["unspecified_media_item_type"] = "unspecified_media_item_type";
    MediaItemType["video"] = "video";
    MediaItemType["zip"] = "zip";
})(MediaItemType || (MediaItemType = {}));
export var MembershipPaymentStatus;
(function (MembershipPaymentStatus) {
    MembershipPaymentStatus["CHARGED"] = "CHARGED";
    MembershipPaymentStatus["CHARGE_FAILED"] = "CHARGE_FAILED";
})(MembershipPaymentStatus || (MembershipPaymentStatus = {}));
export var MissingShippingRatesReason;
(function (MissingShippingRatesReason) {
    MissingShippingRatesReason["MISSING_ADDRESS"] = "MISSING_ADDRESS";
    MissingShippingRatesReason["UNRECOGNISED"] = "UNRECOGNISED";
})(MissingShippingRatesReason || (MissingShippingRatesReason = {}));
export var MissingTaxRatesReason;
(function (MissingTaxRatesReason) {
    MissingTaxRatesReason["MISSING_ADDRESS"] = "MISSING_ADDRESS";
    MissingTaxRatesReason["UNRECOGNISED"] = "UNRECOGNISED";
})(MissingTaxRatesReason || (MissingTaxRatesReason = {}));
export var NameInLineItem;
(function (NameInLineItem) {
    NameInLineItem["LINE_ITEM_DEFAULT"] = "LINE_ITEM_DEFAULT";
})(NameInLineItem || (NameInLineItem = {}));
export var NameInOther;
(function (NameInOther) {
    NameInOther["DELIVERY"] = "DELIVERY";
    NameInOther["OTHER_DEFAULT"] = "OTHER_DEFAULT";
})(NameInOther || (NameInOther = {}));
export var NotRefundableReason;
(function (NotRefundableReason) {
    NotRefundableReason["ACCESS_DENIED"] = "ACCESS_DENIED";
    NotRefundableReason["ALREADY_REFUNDED"] = "ALREADY_REFUNDED";
    NotRefundableReason["DEPOSIT_ONLINE_ITEM"] = "DEPOSIT_ONLINE_ITEM";
    NotRefundableReason["DISABLE_BY_VENDOR"] = "DISABLE_BY_VENDOR";
    NotRefundableReason["EXPIRED"] = "EXPIRED";
    NotRefundableReason["FORBIDDEN"] = "FORBIDDEN";
    NotRefundableReason["INTERNAL_ERROR"] = "INTERNAL_ERROR";
    NotRefundableReason["NOT_FOUND"] = "NOT_FOUND";
    NotRefundableReason["NOT_PAID"] = "NOT_PAID";
    NotRefundableReason["NOT_SUPPORTED"] = "NOT_SUPPORTED";
    NotRefundableReason["OFFLINE"] = "OFFLINE";
    NotRefundableReason["PARTIALLY_PAID"] = "PARTIALLY_PAID";
    NotRefundableReason["PENDING_REFUND"] = "PENDING_REFUND";
    NotRefundableReason["PROVIDER_IS_DOWN"] = "PROVIDER_IS_DOWN";
    NotRefundableReason["ZERO_PRICE"] = "ZERO_PRICE";
})(NotRefundableReason || (NotRefundableReason = {}));
export var OrderActivityType;
(function (OrderActivityType) {
    OrderActivityType["AUTHORIZED_PAYMENT_CAPTURED"] = "AUTHORIZED_PAYMENT_CAPTURED";
    OrderActivityType["AUTHORIZED_PAYMENT_CREATED"] = "AUTHORIZED_PAYMENT_CREATED";
    OrderActivityType["AUTHORIZED_PAYMENT_VOIDED"] = "AUTHORIZED_PAYMENT_VOIDED";
    OrderActivityType["CUSTOM_ACTIVITY"] = "CUSTOM_ACTIVITY";
    OrderActivityType["DOWNLOAD_LINK_SENT"] = "DOWNLOAD_LINK_SENT";
    OrderActivityType["DRAFT_ORDER_CHANGES_APPLIED"] = "DRAFT_ORDER_CHANGES_APPLIED";
    OrderActivityType["EMAIL_EDITED"] = "EMAIL_EDITED";
    OrderActivityType["FULFILLER_EMAIL_SENT"] = "FULFILLER_EMAIL_SENT";
    OrderActivityType["INVOICE_ADDED"] = "INVOICE_ADDED";
    OrderActivityType["INVOICE_REMOVED"] = "INVOICE_REMOVED";
    OrderActivityType["INVOICE_SENT"] = "INVOICE_SENT";
    OrderActivityType["MERCHANT_COMMENT"] = "MERCHANT_COMMENT";
    OrderActivityType["NEW_EXCHANGE_ORDER_CREATED"] = "NEW_EXCHANGE_ORDER_CREATED";
    OrderActivityType["ORDER_CANCELED"] = "ORDER_CANCELED";
    OrderActivityType["ORDER_CREATED_FROM_EXCHANGE"] = "ORDER_CREATED_FROM_EXCHANGE";
    OrderActivityType["ORDER_FULFILLED"] = "ORDER_FULFILLED";
    OrderActivityType["ORDER_NOT_FULFILLED"] = "ORDER_NOT_FULFILLED";
    OrderActivityType["ORDER_PAID"] = "ORDER_PAID";
    OrderActivityType["ORDER_PARTIALLY_PAID"] = "ORDER_PARTIALLY_PAID";
    OrderActivityType["ORDER_PENDING"] = "ORDER_PENDING";
    OrderActivityType["ORDER_PLACED"] = "ORDER_PLACED";
    OrderActivityType["ORDER_REFUNDED"] = "ORDER_REFUNDED";
    OrderActivityType["ORDER_REJECTED"] = "ORDER_REJECTED";
    OrderActivityType["PAYMENT_CANCELED"] = "PAYMENT_CANCELED";
    OrderActivityType["PAYMENT_DECLINED"] = "PAYMENT_DECLINED";
    OrderActivityType["PAYMENT_PENDING"] = "PAYMENT_PENDING";
    OrderActivityType["PAYMENT_REFUNDED"] = "PAYMENT_REFUNDED";
    OrderActivityType["PAYMENT_REFUND_FAILED"] = "PAYMENT_REFUND_FAILED";
    OrderActivityType["PICKUP_READY_EMAIL_SENT"] = "PICKUP_READY_EMAIL_SENT";
    OrderActivityType["RECEIPT_CREATED"] = "RECEIPT_CREATED";
    OrderActivityType["RECEIPT_SENT"] = "RECEIPT_SENT";
    OrderActivityType["REFUNDED_AS_STORE_CREDIT"] = "REFUNDED_AS_STORE_CREDIT";
    OrderActivityType["REFUND_INITIATED"] = "REFUND_INITIATED";
    OrderActivityType["SAVED_PAYMENT_METHOD"] = "SAVED_PAYMENT_METHOD";
    OrderActivityType["SHIPPING_ADDRESS_EDITED"] = "SHIPPING_ADDRESS_EDITED";
    OrderActivityType["SHIPPING_CONFIRMATION_EMAIL_SENT"] = "SHIPPING_CONFIRMATION_EMAIL_SENT";
    OrderActivityType["TRACKING_LINK_ADDED"] = "TRACKING_LINK_ADDED";
    OrderActivityType["TRACKING_NUMBER_ADDED"] = "TRACKING_NUMBER_ADDED";
    OrderActivityType["TRACKING_NUMBER_EDITED"] = "TRACKING_NUMBER_EDITED";
})(OrderActivityType || (OrderActivityType = {}));
export var OrderAppliedDiscountType;
(function (OrderAppliedDiscountType) {
    OrderAppliedDiscountType["GLOBAL"] = "GLOBAL";
    OrderAppliedDiscountType["SHIPPING"] = "SHIPPING";
    OrderAppliedDiscountType["SPECIFIC_ITEMS"] = "SPECIFIC_ITEMS";
})(OrderAppliedDiscountType || (OrderAppliedDiscountType = {}));
export var OrderInHistoryStatus;
(function (OrderInHistoryStatus) {
    OrderInHistoryStatus["Canceled"] = "Canceled";
    OrderInHistoryStatus["Confirmed"] = "Confirmed";
    OrderInHistoryStatus["Fulfilled"] = "Fulfilled";
    OrderInHistoryStatus["Shipped"] = "Shipped";
    OrderInHistoryStatus["Tracking"] = "Tracking";
})(OrderInHistoryStatus || (OrderInHistoryStatus = {}));
export var OrderMerchantDiscountReason;
(function (OrderMerchantDiscountReason) {
    OrderMerchantDiscountReason["EXCHANGED_ITEMS"] = "EXCHANGED_ITEMS";
    OrderMerchantDiscountReason["UNSPECIFIED"] = "UNSPECIFIED";
})(OrderMerchantDiscountReason || (OrderMerchantDiscountReason = {}));
export var OrderMotoPaymentCollectabilityStatus;
(function (OrderMotoPaymentCollectabilityStatus) {
    OrderMotoPaymentCollectabilityStatus["COLLECTABLE"] = "COLLECTABLE";
    OrderMotoPaymentCollectabilityStatus["NONCOLLECTABLE_MISSING_PAYMENT_METHOD"] = "NONCOLLECTABLE_MISSING_PAYMENT_METHOD";
    OrderMotoPaymentCollectabilityStatus["NONCOLLECTABLE_ORDER_IS_CANCELLED"] = "NONCOLLECTABLE_ORDER_IS_CANCELLED";
    OrderMotoPaymentCollectabilityStatus["NONCOLLECTABLE_ORDER_IS_PAID"] = "NONCOLLECTABLE_ORDER_IS_PAID";
    OrderMotoPaymentCollectabilityStatus["NONCOLLECTABLE_ORDER_IS_PENDING"] = "NONCOLLECTABLE_ORDER_IS_PENDING";
    OrderMotoPaymentCollectabilityStatus["NONCOLLECTABLE_ORDER_IS_REJECTED"] = "NONCOLLECTABLE_ORDER_IS_REJECTED";
    OrderMotoPaymentCollectabilityStatus["UNKNOWN"] = "UNKNOWN";
})(OrderMotoPaymentCollectabilityStatus || (OrderMotoPaymentCollectabilityStatus = {}));
export var OrderSortField;
(function (OrderSortField) {
    OrderSortField["CreationDate"] = "CreationDate";
    OrderSortField["CustomerName"] = "CustomerName";
    OrderSortField["DeliveryTimeSlotFromDate"] = "DeliveryTimeSlotFromDate";
    OrderSortField["DeliveryTimeSlotToDate"] = "DeliveryTimeSlotToDate";
    OrderSortField["FulfillmentStatus"] = "FulfillmentStatus";
    OrderSortField["IncrementId"] = "IncrementId";
    OrderSortField["LastUpdated"] = "LastUpdated";
    OrderSortField["PaymentStatus"] = "PaymentStatus";
    OrderSortField["Quantity"] = "Quantity";
    OrderSortField["ShippingStatus"] = "ShippingStatus";
    OrderSortField["Total"] = "Total";
})(OrderSortField || (OrderSortField = {}));
export var OrderStatus;
(function (OrderStatus) {
    OrderStatus["APPROVED"] = "APPROVED";
    OrderStatus["CANCELED"] = "CANCELED";
    OrderStatus["INITIALIZED"] = "INITIALIZED";
    OrderStatus["PENDING"] = "PENDING";
    OrderStatus["REJECTED"] = "REJECTED";
})(OrderStatus || (OrderStatus = {}));
export var PaymentCollectabilityStatus;
(function (PaymentCollectabilityStatus) {
    PaymentCollectabilityStatus["COLLECTABLE"] = "COLLECTABLE";
    PaymentCollectabilityStatus["NONCOLLECTABLE_MISSING_PAYMENT_METHOD"] = "NONCOLLECTABLE_MISSING_PAYMENT_METHOD";
    PaymentCollectabilityStatus["NONCOLLECTABLE_ORDER_IS_CANCELLED"] = "NONCOLLECTABLE_ORDER_IS_CANCELLED";
    PaymentCollectabilityStatus["NONCOLLECTABLE_ORDER_IS_PAID"] = "NONCOLLECTABLE_ORDER_IS_PAID";
    PaymentCollectabilityStatus["UNKNOWN"] = "UNKNOWN";
})(PaymentCollectabilityStatus || (PaymentCollectabilityStatus = {}));
export var PaymentOptionType;
(function (PaymentOptionType) {
    PaymentOptionType["DEPOSIT_ONLINE"] = "DEPOSIT_ONLINE";
    PaymentOptionType["FULL_PAYMENT_OFFLINE"] = "FULL_PAYMENT_OFFLINE";
    PaymentOptionType["FULL_PAYMENT_ONLINE"] = "FULL_PAYMENT_ONLINE";
    PaymentOptionType["MEMBERSHIP"] = "MEMBERSHIP";
    PaymentOptionType["MEMBERSHIP_OFFLINE"] = "MEMBERSHIP_OFFLINE";
})(PaymentOptionType || (PaymentOptionType = {}));
export var PaymentOptionTypeCt;
(function (PaymentOptionTypeCt) {
    PaymentOptionTypeCt["DEPOSIT_ONLINE"] = "DEPOSIT_ONLINE";
    PaymentOptionTypeCt["FULL_PAYMENT_OFFLINE"] = "FULL_PAYMENT_OFFLINE";
    PaymentOptionTypeCt["FULL_PAYMENT_ONLINE"] = "FULL_PAYMENT_ONLINE";
    PaymentOptionTypeCt["MEMBERSHIP"] = "MEMBERSHIP";
})(PaymentOptionTypeCt || (PaymentOptionTypeCt = {}));
export var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["NotPaid"] = "NotPaid";
    PaymentStatus["Paid"] = "Paid";
    PaymentStatus["PartiallyPaid"] = "PartiallyPaid";
    PaymentStatus["Refunded"] = "Refunded";
})(PaymentStatus || (PaymentStatus = {}));
export var PaymentStatusEnumPaymentStatus;
(function (PaymentStatusEnumPaymentStatus) {
    PaymentStatusEnumPaymentStatus["CANCELED"] = "CANCELED";
    PaymentStatusEnumPaymentStatus["DECLINED"] = "DECLINED";
    PaymentStatusEnumPaymentStatus["FULLY_REFUNDED"] = "FULLY_REFUNDED";
    PaymentStatusEnumPaymentStatus["NOT_PAID"] = "NOT_PAID";
    PaymentStatusEnumPaymentStatus["PAID"] = "PAID";
    PaymentStatusEnumPaymentStatus["PARTIALLY_PAID"] = "PARTIALLY_PAID";
    PaymentStatusEnumPaymentStatus["PARTIALLY_REFUNDED"] = "PARTIALLY_REFUNDED";
    PaymentStatusEnumPaymentStatus["PENDING"] = "PENDING";
    PaymentStatusEnumPaymentStatus["PENDING_MERCHANT"] = "PENDING_MERCHANT";
    PaymentStatusEnumPaymentStatus["UNSPECIFIED"] = "UNSPECIFIED";
})(PaymentStatusEnumPaymentStatus || (PaymentStatusEnumPaymentStatus = {}));
export var PickupMethod;
(function (PickupMethod) {
    PickupMethod["PICKUP_POINT"] = "PICKUP_POINT";
    PickupMethod["STORE_PICKUP"] = "STORE_PICKUP";
    PickupMethod["UNKNOWN_METHOD"] = "UNKNOWN_METHOD";
})(PickupMethod || (PickupMethod = {}));
export var PlanDiscountMode;
(function (PlanDiscountMode) {
    PlanDiscountMode["AMOUNT"] = "AMOUNT";
    PlanDiscountMode["PERCENT"] = "PERCENT";
})(PlanDiscountMode || (PlanDiscountMode = {}));
export var PrepareOrderMotoPaymentErrorCode;
(function (PrepareOrderMotoPaymentErrorCode) {
    PrepareOrderMotoPaymentErrorCode["INVALID_AMOUNT"] = "INVALID_AMOUNT";
    PrepareOrderMotoPaymentErrorCode["ORDER_ALREADY_PAID"] = "ORDER_ALREADY_PAID";
    PrepareOrderMotoPaymentErrorCode["ORDER_CANCELED"] = "ORDER_CANCELED";
    PrepareOrderMotoPaymentErrorCode["PAYMENT_METHODS_NOT_FOUND"] = "PAYMENT_METHODS_NOT_FOUND";
})(PrepareOrderMotoPaymentErrorCode || (PrepareOrderMotoPaymentErrorCode = {}));
export var ProductBrandFieldName;
(function (ProductBrandFieldName) {
    ProductBrandFieldName["brand"] = "brand";
})(ProductBrandFieldName || (ProductBrandFieldName = {}));
export var ProductFieldName;
(function (ProductFieldName) {
    ProductFieldName["allowOneTimePurchase"] = "allowOneTimePurchase";
    ProductFieldName["brand"] = "brand";
    ProductFieldName["categories"] = "categories";
    ProductFieldName["comparePrice"] = "comparePrice";
    ProductFieldName["createVersion"] = "createVersion";
    ProductFieldName["created"] = "created";
    ProductFieldName["creationDate"] = "creationDate";
    ProductFieldName["deleted"] = "deleted";
    ProductFieldName["description"] = "description";
    ProductFieldName["discountedPrice"] = "discountedPrice";
    ProductFieldName["fulfillerId"] = "fulfillerId";
    ProductFieldName["handleId"] = "handleId";
    ProductFieldName["hideFromPos"] = "hideFromPos";
    ProductFieldName["id"] = "id";
    ProductFieldName["inventoryStatus"] = "inventoryStatus";
    ProductFieldName["lastUpdated"] = "lastUpdated";
    ProductFieldName["name"] = "name";
    ProductFieldName["optionChoices"] = "optionChoices";
    ProductFieldName["planIds"] = "planIds";
    ProductFieldName["preOrder"] = "preOrder";
    ProductFieldName["price"] = "price";
    ProductFieldName["productType"] = "productType";
    ProductFieldName["readyToSellExternalAppId"] = "readyToSellExternalAppId";
    ProductFieldName["ribbon"] = "ribbon";
    ProductFieldName["shippingProductGroupId"] = "shippingProductGroupId";
    ProductFieldName["sku"] = "sku";
    ProductFieldName["slug"] = "slug";
    ProductFieldName["taxGroupId"] = "taxGroupId";
    ProductFieldName["visible"] = "visible";
})(ProductFieldName || (ProductFieldName = {}));
export var ProductGroupRateCalculationSettingType;
(function (ProductGroupRateCalculationSettingType) {
    ProductGroupRateCalculationSettingType["APPLY_HIGHEST_RATE_ONCE"] = "APPLY_HIGHEST_RATE_ONCE";
    ProductGroupRateCalculationSettingType["APPLY_RATE_ONCE_PER_GROUP"] = "APPLY_RATE_ONCE_PER_GROUP";
    ProductGroupRateCalculationSettingType["APPLY_RATE_TO_EACH_PRODUCT"] = "APPLY_RATE_TO_EACH_PRODUCT";
})(ProductGroupRateCalculationSettingType || (ProductGroupRateCalculationSettingType = {}));
export var ProductOptionType;
(function (ProductOptionType) {
    ProductOptionType["COLOR"] = "COLOR";
    ProductOptionType["DROP_DOWN"] = "DROP_DOWN";
})(ProductOptionType || (ProductOptionType = {}));
export var ProductSortField;
(function (ProductSortField) {
    ProductSortField["ComparePrice"] = "ComparePrice";
    ProductSortField["CreateVersion"] = "CreateVersion";
    ProductSortField["CreationDate"] = "CreationDate";
    ProductSortField["DiscountedPrice"] = "DiscountedPrice";
    ProductSortField["Id"] = "Id";
    ProductSortField["LastUpdated"] = "LastUpdated";
    ProductSortField["Name"] = "Name";
    ProductSortField["Price"] = "Price";
    ProductSortField["comparePrice"] = "comparePrice";
    ProductSortField["createVersion"] = "createVersion";
    ProductSortField["creationDate"] = "creationDate";
    ProductSortField["discountedPrice"] = "discountedPrice";
    ProductSortField["id"] = "id";
    ProductSortField["lastUpdated"] = "lastUpdated";
    ProductSortField["name"] = "name";
    ProductSortField["price"] = "price";
})(ProductSortField || (ProductSortField = {}));
export var ProductType;
(function (ProductType) {
    ProductType["Digital"] = "Digital";
    ProductType["Physical"] = "Physical";
})(ProductType || (ProductType = {}));
export var RateType;
(function (RateType) {
    RateType["AUTO_RATE"] = "AUTO_RATE";
    RateType["FALLBACK_RATE"] = "FALLBACK_RATE";
    RateType["MANUAL_RATE"] = "MANUAL_RATE";
    RateType["NO_TAX_COLLECTED"] = "NO_TAX_COLLECTED";
})(RateType || (RateType = {}));
export var ReadStatus;
(function (ReadStatus) {
    ReadStatus["NotRead"] = "NotRead";
    ReadStatus["Read"] = "Read";
})(ReadStatus || (ReadStatus = {}));
export var RecordOrderManualPaymentErrorCode;
(function (RecordOrderManualPaymentErrorCode) {
    RecordOrderManualPaymentErrorCode["INVALID_AMOUNT"] = "INVALID_AMOUNT";
    RecordOrderManualPaymentErrorCode["ORDER_ALREADY_PAID"] = "ORDER_ALREADY_PAID";
    RecordOrderManualPaymentErrorCode["ORDER_CANCELED"] = "ORDER_CANCELED";
})(RecordOrderManualPaymentErrorCode || (RecordOrderManualPaymentErrorCode = {}));
export var RecoveryStatusType;
(function (RecoveryStatusType) {
    RecoveryStatusType["NOT_RECOVERED"] = "NOT_RECOVERED";
    RecoveryStatusType["RECOVERED"] = "RECOVERED";
})(RecoveryStatusType || (RecoveryStatusType = {}));
export var RefundAbilityStatus;
(function (RefundAbilityStatus) {
    RefundAbilityStatus["MANUAL"] = "MANUAL";
    RefundAbilityStatus["NOT_REFUNDABLE"] = "NOT_REFUNDABLE";
    RefundAbilityStatus["REFUNDABLE"] = "REFUNDABLE";
})(RefundAbilityStatus || (RefundAbilityStatus = {}));
export var RestockType;
(function (RestockType) {
    RestockType["ALL_ITEMS"] = "ALL_ITEMS";
    RestockType["NO_ITEMS"] = "NO_ITEMS";
    RestockType["SOME_ITEMS"] = "SOME_ITEMS";
})(RestockType || (RestockType = {}));
export var RestrictableOperation;
(function (RestrictableOperation) {
    RestrictableOperation["ALLOW"] = "ALLOW";
    RestrictableOperation["WARN"] = "WARN";
})(RestrictableOperation || (RestrictableOperation = {}));
export var RuleType;
(function (RuleType) {
    RuleType["DECIMAL_GT"] = "DECIMAL_GT";
    RuleType["DECIMAL_GTE"] = "DECIMAL_GTE";
    RuleType["DECIMAL_LT"] = "DECIMAL_LT";
    RuleType["DECIMAL_LTE"] = "DECIMAL_LTE";
    RuleType["DECIMAL_MAX_SCALE"] = "DECIMAL_MAX_SCALE";
    RuleType["FIELD_NOT_ALLOWED"] = "FIELD_NOT_ALLOWED";
    RuleType["FORMAT"] = "FORMAT";
    RuleType["INVALID_ENUM_VALUE"] = "INVALID_ENUM_VALUE";
    RuleType["MAX"] = "MAX";
    RuleType["MAX_LENGTH"] = "MAX_LENGTH";
    RuleType["MAX_SIZE"] = "MAX_SIZE";
    RuleType["MIN"] = "MIN";
    RuleType["MIN_LENGTH"] = "MIN_LENGTH";
    RuleType["MIN_SIZE"] = "MIN_SIZE";
    RuleType["ONE_OF_ALIGNMENT"] = "ONE_OF_ALIGNMENT";
    RuleType["OTHER"] = "OTHER";
    RuleType["REQUIRED_FIELD"] = "REQUIRED_FIELD";
    RuleType["VALIDATION"] = "VALIDATION";
})(RuleType || (RuleType = {}));
export var SalesChannels;
(function (SalesChannels) {
    SalesChannels["Amazon"] = "Amazon";
    SalesChannels["Ebay"] = "Ebay";
    SalesChannels["OtherPlatform"] = "OtherPlatform";
    SalesChannels["Pos"] = "Pos";
    SalesChannels["Web"] = "Web";
    SalesChannels["WixAppStore"] = "WixAppStore";
})(SalesChannels || (SalesChannels = {}));
export var ScopeType;
(function (ScopeType) {
    ScopeType["CATALOG_ITEM"] = "CATALOG_ITEM";
    ScopeType["CUSTOM_FILTER"] = "CUSTOM_FILTER";
    ScopeType["UNDEFINED_SCOPE"] = "UNDEFINED_SCOPE";
})(ScopeType || (ScopeType = {}));
export var Severity;
(function (Severity) {
    Severity["ERROR"] = "ERROR";
    Severity["WARNING"] = "WARNING";
})(Severity || (Severity = {}));
export var ShippingLabelUnavailabilityReason;
(function (ShippingLabelUnavailabilityReason) {
    ShippingLabelUnavailabilityReason["FEATURE_KILLED"] = "FEATURE_KILLED";
    ShippingLabelUnavailabilityReason["INELIGIBLE_STORE"] = "INELIGIBLE_STORE";
})(ShippingLabelUnavailabilityReason || (ShippingLabelUnavailabilityReason = {}));
export var ShippingStatus;
(function (ShippingStatus) {
    ShippingStatus["Canceled"] = "Canceled";
    ShippingStatus["Fulfilled"] = "Fulfilled";
    ShippingStatus["NotFulfilled"] = "NotFulfilled";
})(ShippingStatus || (ShippingStatus = {}));
export var SortDirection;
(function (SortDirection) {
    SortDirection["Ascending"] = "Ascending";
    SortDirection["Descending"] = "Descending";
})(SortDirection || (SortDirection = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var Source;
(function (Source) {
    Source["UNSUPPORTED_SOURCE"] = "UNSUPPORTED_SOURCE";
    Source["WIX_FACEBOOK_ADS"] = "WIX_FACEBOOK_ADS";
})(Source || (Source = {}));
export var StoreVariantSortField;
(function (StoreVariantSortField) {
    StoreVariantSortField["ProductNumericId"] = "ProductNumericId";
    StoreVariantSortField["VariantId"] = "VariantId";
    StoreVariantSortField["productNumericId"] = "productNumericId";
    StoreVariantSortField["variantId"] = "variantId";
})(StoreVariantSortField || (StoreVariantSortField = {}));
export var StringOperator;
(function (StringOperator) {
    StringOperator["Contains"] = "Contains";
    StringOperator["Equals"] = "Equals";
})(StringOperator || (StringOperator = {}));
export var SubscriptionFrequency;
(function (SubscriptionFrequency) {
    SubscriptionFrequency["DAY"] = "DAY";
    SubscriptionFrequency["MONTH"] = "MONTH";
    SubscriptionFrequency["UNDEFINED"] = "UNDEFINED";
    SubscriptionFrequency["WEEK"] = "WEEK";
    SubscriptionFrequency["YEAR"] = "YEAR";
})(SubscriptionFrequency || (SubscriptionFrequency = {}));
export var SubscriptionPlanFrequency;
(function (SubscriptionPlanFrequency) {
    SubscriptionPlanFrequency["DAY"] = "DAY";
    SubscriptionPlanFrequency["MONTH"] = "MONTH";
    SubscriptionPlanFrequency["UNDEFINED"] = "UNDEFINED";
    SubscriptionPlanFrequency["WEEK"] = "WEEK";
    SubscriptionPlanFrequency["YEAR"] = "YEAR";
})(SubscriptionPlanFrequency || (SubscriptionPlanFrequency = {}));
export var SubscriptionSettingsFrequency;
(function (SubscriptionSettingsFrequency) {
    SubscriptionSettingsFrequency["DAY"] = "DAY";
    SubscriptionSettingsFrequency["MONTH"] = "MONTH";
    SubscriptionSettingsFrequency["UNDEFINED"] = "UNDEFINED";
    SubscriptionSettingsFrequency["WEEK"] = "WEEK";
    SubscriptionSettingsFrequency["YEAR"] = "YEAR";
})(SubscriptionSettingsFrequency || (SubscriptionSettingsFrequency = {}));
export var TransactionStatus;
(function (TransactionStatus) {
    TransactionStatus["APPROVED"] = "APPROVED";
    TransactionStatus["AUTHORIZED"] = "AUTHORIZED";
    TransactionStatus["CANCELED"] = "CANCELED";
    TransactionStatus["DECLINED"] = "DECLINED";
    TransactionStatus["PARTIALLY_REFUNDED"] = "PARTIALLY_REFUNDED";
    TransactionStatus["PENDING"] = "PENDING";
    TransactionStatus["PENDING_MERCHANT"] = "PENDING_MERCHANT";
    TransactionStatus["REFUNDED"] = "REFUNDED";
    TransactionStatus["UNDEFINED"] = "UNDEFINED";
    TransactionStatus["VOIDED"] = "VOIDED";
})(TransactionStatus || (TransactionStatus = {}));
export var TriggerTargetType;
(function (TriggerTargetType) {
    TriggerTargetType["ALL_ITEMS"] = "ALL_ITEMS";
    TriggerTargetType["SPECIFIC_ITEMS"] = "SPECIFIC_ITEMS";
    TriggerTargetType["UNDEFINED"] = "UNDEFINED";
})(TriggerTargetType || (TriggerTargetType = {}));
export var TriggerType;
(function (TriggerType) {
    TriggerType["AND"] = "AND";
    TriggerType["CUSTOM"] = "CUSTOM";
    TriggerType["ITEM_QUANTITY"] = "ITEM_QUANTITY";
    TriggerType["MIN_SUBTOTAL"] = "MIN_SUBTOTAL";
    TriggerType["UNDEFINED_TRIGGER"] = "UNDEFINED_TRIGGER";
})(TriggerType || (TriggerType = {}));
export var Type;
(function (Type) {
    Type["BUY_X_GET_Y"] = "BUY_X_GET_Y";
    Type["SPECIFIC_ITEMS"] = "SPECIFIC_ITEMS";
    Type["UNDEFINED"] = "UNDEFINED";
})(Type || (Type = {}));
export var V1DiscountType;
(function (V1DiscountType) {
    V1DiscountType["GLOBAL"] = "GLOBAL";
    V1DiscountType["SHIPPING"] = "SHIPPING";
    V1DiscountType["SPECIFIC_ITEMS"] = "SPECIFIC_ITEMS";
    V1DiscountType["UNDEFINED"] = "UNDEFINED";
})(V1DiscountType || (V1DiscountType = {}));
export var VatType;
(function (VatType) {
    VatType["CNPJ"] = "CNPJ";
    VatType["CPF"] = "CPF";
    VatType["UNSPECIFIED_TAX_TYPE"] = "UNSPECIFIED_TAX_TYPE";
})(VatType || (VatType = {}));
export var VatTypeInput;
(function (VatTypeInput) {
    VatTypeInput["CNPJ"] = "CNPJ";
    VatTypeInput["CPF"] = "CPF";
    VatTypeInput["UNSPECIFIED"] = "UNSPECIFIED";
})(VatTypeInput || (VatTypeInput = {}));
export var WeightUnit;
(function (WeightUnit) {
    WeightUnit["KG"] = "KG";
    WeightUnit["LB"] = "LB";
    WeightUnit["UNSPECIFIED_WEIGHT_UNIT"] = "UNSPECIFIED_WEIGHT_UNIT";
})(WeightUnit || (WeightUnit = {}));
//# sourceMappingURL=schemaTypes.js.map